module.exports = __webpack_public_path__ + "img/waterAndSewerWorkZones.ad42992e.svg";